import React, {useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { httpGet , crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import { languagePicker, getLabel } from '../../utils';
import SEO from '../../components/SEO/SEO';
import HomeHolder from './HomePageStyles';
import ListItem from '../../components/ListItem/ListItem';
import SimpleSearch from '../../components/SearchBar/SimpleSearch';

const HomePage = (props) => {

	const [homePagesTitles, setHomePagesTitles] = useState([]);
	const [livestreams, setLivestreams] = useState([]);
	const [lastVideos, setLatestVideos] = useState([]);
	const [fadeOutTiming, setfadeOutTiming] = useState(10000);
	const [pageThumb, setPageThumb] = useState([]);
	const siteURL = window.location.origin;
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
	const pageTitle = pageLang === "en" ? "CPAC - Watch for Democracy" : "CPAC - Pour la démocratie";
	const pageDesc = pageLang === "en" ? "CPAC.ca is your destination for Politics and Public Affairs in Canada." : "CPAC.ca est votre destination pour la politique et les affaires publiques au Canada.";
	

	const stripIncompleteTiles = (tiles) => {
		const tmpTiles = {}
		tmpTiles.viewmode = tiles.viewmode
		tmpTiles.item = []
		for (const tile of tiles.item) {
			if (tile.url && tile.url.length > 0) {
				tmpTiles.item.push(tile)
			}
		}
		return tmpTiles
	}

	useEffect(function() {
		const craftConf = crafterConf.getConfig();
		const serviceUrl = composeUrl(craftConf , process.env.REACT_APP_CONTENT_MODEL_ENDPOINT); 

		httpGet(serviceUrl, {url:"/site/website/home/index.xml", crafterSite:craftConf.site}).subscribe(data => {
			if (data) {
				let fieldNames = ["homePageTitles.altImageTxt_s", "homePageTitles.image_s", "homePageTitles.url_s", 
				"livestreams.title_t", "livestreams.description_t", "livestreams.image_s",
				"livestreams.altImageTxt_s","livestreams.category_t", "livestreams.categoryURL_s", "livestreams.url_s",
				"lastVideos;title_t", "lastVideos;seeAllUrl_s",
				"lastVideos.title_t","lastVideos.description_t", "lastVideos.image_s",
				"lastVideos.altImageTxt_s","lastVideos.category_t", "lastVideos.categoryURL_s", "lastVideos.url_s", "thumbnailResult.image_s", "thumbnailResult.altImageTxt_s"]
				languagePicker(data, fieldNames);
				let dataPage = data.page;
				setHomePagesTitles(stripIncompleteTiles(dataPage.homePageTitles));
				setfadeOutTiming(dataPage.fade_seconds_i * 1000);
				setLivestreams(dataPage.livestreams);
				setLatestVideos(dataPage.lastVideos);
				setPageThumb(dataPage.thumbnailResult.item[0].image);
			}
		});
	},[props.current_lang]);

	return (
		<>
		<SEO pageDesc={pageDesc} pageURL={siteURL} title={pageTitle} pageTitle={pageTitle} image={siteURL + pageThumb} type="website" pageLocale={pageLocale} />
		<HomeHolder>
			{(livestreams && livestreams.length === 0) || (lastVideos && lastVideos.length === 0) || homePagesTitles.length === 0 ? <h1><div className="loading"/>{getLabel("LOADING")}</h1> : 
			<div className="content-wrapper" itemScope itemType="https://schema.org/WebPageElement">
				<div className="content">
					<div className="content__full">
						{ homePagesTitles && <ListItem items={homePagesTitles} fadeOutTiming={ Number(fadeOutTiming) } /> }
					</div>
					<div className="content__left" itemProp="mainEntityOfPage">
						<div className="">
							<h2 className="feature__title" itemProp='headline'>{getLabel("TODAY_ON_CPAC")}</h2>
						</div>
						{ livestreams && <ListItem items={livestreams}/> }
					</div>
					<aside className="content__right" itemScope itemType="https://schema.org/WPSideBar">
						<SimpleSearch />
						{ lastVideos && <ListItem items={lastVideos}/> }
					</aside>
				</div>
			</div>}
		</HomeHolder>
		</>
	)
}

const mapStateToProps = (store) => ({
	current_lang: store.language.current,
});

export default connect(mapStateToProps,null)(HomePage);
